// Carregador de produtos complementares
// Força o carregamento e oculta se não houver produtos

console.log('📜 Script complementary-products-loader.js carregado');

document.addEventListener('DOMContentLoaded', function() {
  console.log('🔄 Iniciando carregamento de produtos complementares...');
  
  // Aguardar um pouco para garantir que o DOM está totalmente carregado
  setTimeout(() => {
    const productRecommendations = document.querySelector('product-recommendations');
    console.log('🔍 Elemento encontrado após timeout:', productRecommendations);
  
  if (productRecommendations) {
    console.log('✅ Elemento product-recommendations encontrado');
    
    const productId = productRecommendations.dataset.productId;
    const sectionId = productRecommendations.dataset.sectionId;
    
    console.log('📋 Product ID:', productId, 'Section ID:', sectionId);
    
    if (productId && sectionId) {
      // Começar carregamento imediatamente
      const apiUrl = `/recommendations/products?product_id=${productId}&limit=10&intent=complementary&section_id=${sectionId}`;
      
      console.log('🌐 Fazendo requisição para:', apiUrl);
      
      fetch(apiUrl)
        .then(response => response.text())
        .then(html => {
          console.log('📥 Resposta recebida:', html.length, 'caracteres');
          
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const recommendations = tempDiv.querySelector('product-recommendations');
          
          // Verificar se há produtos na resposta
          const hasProducts = recommendations && 
                             recommendations.innerHTML.trim() && 
                             recommendations.querySelector('.card-wrapper');
          
          console.log('🔍 Tem produtos?', hasProducts);
          
          if (hasProducts) {
            // Substituir conteúdo e mostrar bloco
            productRecommendations.innerHTML = recommendations.innerHTML;
            productRecommendations.classList.add('has-products');
            console.log('✅ Produtos carregados e bloco exibido');
            console.log('✅ Produtos complementares carregados:', recommendations.querySelectorAll('.card-wrapper').length, 'produtos');
            
            // Configurar eventos de formulário
            setupCartForms(); 
          } else {
            // Manter oculto se não há produtos
            productRecommendations.classList.remove('has-products');
            console.log('❌ Nenhum produto complementar - bloco permanece oculto');
            console.log('🔍 HTML recebido:', html.substring(0, 500));
            console.log('🔍 Recommendations element:', recommendations);
          }
        })
        .catch(error => {
          console.error('Erro ao carregar produtos complementares:', error);
          // Manter oculto em caso de erro
          productRecommendations.classList.remove('has-products');
        });
    } else {
      // Se não há IDs válidos, manter oculto
      productRecommendations.classList.remove('has-products');
      console.log('❌ IDs inválidos - bloco permanece oculto');
      console.log('🔍 Product ID:', productId, 'Section ID:', sectionId);
    }
  } else {
    console.log('❌ Elemento product-recommendations não encontrado');
    console.log('🔍 Elementos encontrados:', document.querySelectorAll('product-recommendations').length);
    console.log('🔍 Todos os elementos:', document.querySelectorAll('*').length);
  }
  }, 1000); // Aguardar 1 segundo
});

// Função para configurar formulários de carrinho
function setupCartForms() {
  const forms = document.querySelectorAll('product-recommendations form[data-type="add-to-cart-form"]');
  
  forms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const submitButton = this.querySelector('button[type="submit"]');
      const originalText = submitButton.textContent;
      
      // Mostrar loading
      submitButton.disabled = true;
      submitButton.textContent = 'Adicionando...';
      
      try {
        const formData = new FormData(this);
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        
        if (response.ok) {
          const result = await response.json();
          console.log('✅ Produto adicionado ao carrinho:', result);
          
          // Feedback visual
          submitButton.textContent = '✅ Adicionado!';
          submitButton.style.backgroundColor = '#28a745';
          
          // Buscar dados atualizados do carrinho
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          // Disparar eventos que o tema usa
          document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart: cart }
          }));
          
          // Evento específico para refresh do mini cart
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { 
              cart: cart,
              openMiniCart: true // Abrir mini cart automaticamente
            }
          }));
          
          // Atualizar contador do carrinho
          const cartCount = document.querySelector('cart-count');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
          }
          
          // Disparar evento de notificação do carrinho
          document.dispatchEvent(new CustomEvent('cart-notification:show', {
            bubbles: true,
            cancelable: true,
            detail: {
              status: 'success',
              variant: result
            }
          }));
          
          // Tentar abrir mini cart diretamente se os eventos não funcionarem
          setTimeout(() => {
            const cartDrawer = document.querySelector('cart-drawer');
            const miniCart = document.querySelector('.mini-cart');
            
            if (cartDrawer) {
              cartDrawer.open = true;
              console.log('✅ Mini cart (drawer) aberto');
            } else if (miniCart) {
              miniCart.classList.add('is-open');
              console.log('✅ Mini cart aberto');
            }
          }, 500);
          
          // Restaurar botão após 2 segundos
          setTimeout(() => {
            submitButton.textContent = originalText;
            submitButton.style.backgroundColor = '';
            submitButton.disabled = false;
          }, 2000);
          
        } else {
          throw new Error('Erro ao adicionar produto');
        }
        
      } catch (error) {
        console.error('Erro ao adicionar ao carrinho:', error);
        submitButton.textContent = '❌ Erro';
        submitButton.style.backgroundColor = '#dc3545';
        
        setTimeout(() => {
          submitButton.textContent = originalText;
          submitButton.style.backgroundColor = '';
          submitButton.disabled = false;
        }, 2000);
      }
    });
  });
}
